export const CONTACT_TYPES = [
  { label: 'Email', value: 'EMAIL' },
  { label: 'Fax', value: 'FAX' },
  { label: 'Landline', value: 'LANDLINE' },
  { label: 'Mobile', value: 'MOBILE' },
  { label: 'Instagram', value: 'INSTAGRAM' },
  { label: 'Facebook', value: 'FACEBOOK' },
  { label: 'LinkedIn', value: 'LINKED_IN' },
  { label: 'WhatsApp', value: 'WHATS_APP' },
  { label: 'Telegram', value: 'TELEGRAM' },
  { label: 'Viber', value: 'VIBER' },
];
